// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"BH","text":"BI","subText":"BJ","toggleContainer":"BK","checked":"BL"};